module.exports = __webpack_public_path__ + "img/文字_D级赛事@3x.4483e62e.png";